import React from "react"
import FieldProto from "../../proto/field-proto";
import {GlistSkin} from "../../../gd-modules/generic-list/const";

export type FieldGlistGroupProps = {
    field           : FieldProto
    glist           : any
    data            : any,  // is it model or value ?
    isCollapsed?    : boolean
};

export default function FieldGlistGroup(props:FieldGlistGroupProps):React.ReactElement|false {

    switch (props.glist.skinName) {
        case GlistSkin.SKIN_CARDS   :
            return <props.field.components.glistGroupStandard {...props} />

        case GlistSkin.SKIN_MODERN  :
        default                     :
            return <props.field.components.glistGroupModern {...props} />
    }


}
